import React, { FC, useEffect, useRef, useState } from "react";
import "./Top.scss";
import Modal from "react-modal";
import UseTarms from "../UseTarms/UseTarms";
import FileInput from "../../app/FileInput";
import { useNavigate } from "react-router-dom";
import useSettionStrage from "../../app/useSettionStrage";

interface TopProps {}

const Top: FC<TopProps> = () => {
  const [isAgree, setIsAgree] = useSettionStrage("isAgree", false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [isSameError, setIsSameError] = useState(false);
  const [isNumberError, setIsNumberError] = useState(false);
  const [isFileTypeError, setIsFileTypeError] = useState(false);
  const [isSizeError, setIsSizeError] = useState(false);

  const [isLess, setIsLess] = useState(false);

  const [photos, setPhotos] = useState<File[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);

  const navigate = useNavigate();

  const limit = 6;

  const resetErrors = () => {
    setIsSameError(false);
    setIsNumberError(false);
    setIsFileTypeError(false);
  };

  const fileUpload = (): void => {
    inputRef.current?.click();
  };

  const handleFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files === null || event.target.files.length === 0) {
      return;
    }
    const files = Object.values(event.target.files).concat();
    event.target.value = "";
    resetErrors();
    const pickedPhotos = files.filter((file) => {
      if (!["image/jpeg"].includes(file.type)) {
        setIsFileTypeError(true);
        return false;
      }
      const existsSameSize = photos.some((photo) => photo.size === file.size);
      if (existsSameSize) {
        setIsSameError(true);
        return false;
      }
      return true;
    });

    if (pickedPhotos.length < limit) {
      setIsLess(true);
      setPhotos([]);
      return;
    } else {
      const concatPhotos = photos.concat(pickedPhotos);
      if (concatPhotos.length >= limit + 1) {
        setIsNumberError(true);
      }
      setPhotos(concatPhotos.slice(0, concatPhotos.length));
    }
  };

  useEffect(() => {
    if (photos.length >= limit) {
      navigate("/generated", { state: photos });
    }
    window.scrollTo(0, 0);
  }, [navigate, photos]);

  return (
    <div className="Top" data-testid="Top">
      <h1>Logo</h1>
      <div className="box">
        <p>
          選んだ写真をAIが自動採点して
          <br />
          あなただけのランキング画像を作成します
        </p>
        <img
          className="cover"
          src={`${process.env.PUBLIC_URL}/img/cover.png`}
          alt=""
        />

        <div className="errorAleat">
          {isSameError && (
            <p className="error">*すでに選択された画像と同じものは表示されません。</p>
          )}
          {isNumberError && <p className="error">*6枚を超えて選択された画像は表示されません。</p>}
          {isFileTypeError && <p className="error">*jpg以外のファイル形式は表示されません。</p>}
          {isSizeError && <p className="error">4MB以上のファイルはご利用できません。</p>}
        </div>
        {!isLess ? (
          <p>まずは写真を6枚選択しましょう</p>
        ) : (
          <p className="error">写真は6枚以上選択してください</p>
        )}

        <div className="checkbox-wrapper">
          <div className="row">
            <label>
              <input
                type="checkbox"
                onChange={() => setIsAgree((prev: boolean) => !prev)}
                checked={isAgree}
                name="tarms"
              />
            </label>
            <span>
              <span className="linktarm" onClick={() => setModalIsOpen(true)}>
                利用規約
              </span>
              に同意します
            </span>
          </div>
          <FileInput onFileInputChange={handleFile} ref={inputRef} />
          <button disabled={!isAgree} onClick={fileUpload}>
            写真を選択する
          </button>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={modalStyles}
        ariaHideApp={false}
      >
        <div className="wrapper">
          <UseTarms />
          <button
            className="btnclose"
            onClick={() => setModalIsOpen(false)}
          ></button>
        </div>
      </Modal>
    </div>
  );
};

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  content: {
    Position: "absolute",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    transform: "translate(-50%, -50%)",
    borderRadius: "15px",
    width: "90vw",
    height: "92vh",
  },
};

export default Top;
